module.exports = __webpack_public_path__ + "media/images/close_icon_white-be34c98e8bc30453a15a4f6cd25b16cf.svg";